import type { TeamId } from "@arcade-hockey/shared";
import { tuning } from "@arcade-hockey/sim";

// Sim-space x-coordinate of the goal-line crease center for a team. Home
// defends -x; away defends +x. The "enemy net" — i.e. the net a player is
// trying to score on — is the one belonging to the opposing team.
export function enemyNetX(teamId: TeamId): number {
  const halfLength = tuning.rink.length / 2;
  const goalLineOffset = tuning.rink.goalLineOffset;
  return teamId === "home" ? halfLength - goalLineOffset : -halfLength + goalLineOffset;
}

// Attack direction along the x-axis: +1 for home (attacks +x), -1 for away.
export function attackDir(teamId: TeamId): number {
  return teamId === "home" ? 1 : -1;
}
